import Model from "./CommonModel";

export default class AbnLookup extends Model {
  resource() {
    return "public/abn-lookup";
  }
}
